import {
  concat, map, find, filter,
} from 'lodash';
import {
  generateInternalClientsEventColumns, generateInternalEventColumns, generateLSportsEventColumns,
} from '@/components/odds-checker/table-configuration/odds-checker-table-helper';

const generateNonSuperAdminColumns = (operator) => concat(generateInternalEventColumns(operator), generateLSportsEventColumns());
const generateSuperAdminColumns = () => concat(generateInternalClientsEventColumns(), generateLSportsEventColumns());

export const generateDefaultOddsCheckerColumns = (isSuperAdmin, operator) => {
  if (isSuperAdmin) {
    return generateSuperAdminColumns();
  }
  return generateNonSuperAdminColumns(operator);
};

export const mapApiConfigToTableColumns = (apiList, isSuperAdmin, operator) => {
  const columns = generateDefaultOddsCheckerColumns(isSuperAdmin, operator);

  const mappedColumns = map(columns, (column) => {
    const match = find(apiList, (apiItem) => apiItem.type === column.type
      && apiItem.source === column.source
      && apiItem.gateway === column.gateway
      // Only check operatorId if it exists on the column
      && (column.operatorId ? apiItem.operatorId === column.operatorId : true));

    if (match) {
      return {
        ...column,
        isActive: match.isActive,
        position: match.position,
      };
    }
    return column;
  });

  const operatorIds = [...new Set(map(filter(mappedColumns, (bookmaker) => (bookmaker.isActive || bookmaker.alwaysDisplay) && bookmaker.operatorId !== null), 'operatorId'))];
  const sources = [...new Set(map(filter(mappedColumns, (bookmaker) => (bookmaker.isActive || bookmaker.alwaysDisplay) && bookmaker.source !== null), 'source'))];

  return {
    columns: mappedColumns,
    operatorIds,
    sources,
  };
};
